jQuery(document).ready(function($) {
    $('#send_to_mailchimp_button').click(function(evt) {
        evt.preventDefault();
        if( !$('#send_to_mailchimp_post_id').val() ) { return; }

        $.post( ajaxurl, {
                action: 'abm_handle_mailchimp_ajax',
                send_to_subscribers: $('#send_to_subscribers')[0].checked,
                send_to_contacts: $('#send_to_contacts')[0].checked,
                auto_send: $('#auto_send')[0].checked,
                post_id: $('#send_to_mailchimp_post_id').val(),
                abm_mailchimp_metaboxes_nonce: AbmMailchimpMetaboxes.nonce
            },

            function( response ) {
                $('#writing_mailchimp_metabox_id .inside').html(response);
            }
        );
    });
});
